package net.bothosting.docs.pages.troubleshooting

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initBetter_sqlite_errorPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("troubleshooting/better_sqlite_error.md", FrontMatterElement.EmptyMap))
}

@Page("/troubleshooting/better-sqlite-error")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Better_sqlite_errorPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("better-sqlite-error") }) {
        org.jetbrains.compose.web.dom.Text("Better-sqlite error")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This issue usually originates from the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("node_modules")
        }
        org.jetbrains.compose.web.dom.Text(" folder. To fix it:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Delete the folder.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Make sure you are using the correct Node.js version, ideally the same version you use in your development environment, such as Visual Studio Code.")
        }
    }
}
